var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.closestPups),function(pup){return _c('pup-item',_vm._g({key:pup.pargoPointCode,attrs:{"pup":pup}},_vm.$listeners))}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('th',{staticStyle:{"padding":"0 !important"},attrs:{"colspan":"2"}})])])
}]

export { render, staticRenderFns }